import { jsx as _jsx } from "react/jsx-runtime";
const levelClasses = {
    1: "text-xl font-medium text-zinc-900 sm:text-2xl",
    2: "text-lg font-medium text-zinc-900 sm:text-xl",
    3: "text-base font-medium text-zinc-800 sm:text-lg",
    4: "text-sm font-medium text-zinc-800 sm:text-[0.9375rem]",
    5: "text-sm font-medium text-zinc-800",
    6: "text-xs font-medium uppercase tracking-wide text-zinc-700",
};
export function Heading({ level = 4, className = "", children, ...rest }) {
    const Tag = `h${level}`;
    return (_jsx(Tag, { className: [levelClasses[level], className].join(" "), ...rest, children: children }));
}
